export interface ProgramaSistema {
  programId: number;
  name: string;
  slug: string;
  coverUrl: string;
  description: string;
  schedule: string;
  timezone: string;
  hostName: string;
  hostPhotoUrl: string;
  hostSlug: string;
  radioName: string;
  radioFrequency: string;
  category: string;
  followers: number;
  rankingPosition: number;
  rankingTotal: number;
  isActive: boolean;
  isTrending: boolean;
  tags: string[];
  weeklyGrowth: number;
  postsCount: number;
  videosCount: number;
  eventsCount: number;
  contestsCount: number;
  clubMembers: number;
}

export const programasSistema: ProgramaSistema[] = [
  {
    programId: 1,
    name: 'Mañanas Argentinas',
    slug: 'mananas-argentinas',
    coverUrl: 'https://readdy.ai/api/search-image?query=Professional%20radio%20morning%20show%20studio%20scene%20with%20warm%20sunrise%20lighting%20through%20large%20windows%2C%20multiple%20microphones%20on%20a%20wooden%20desk%2C%20coffee%20cups%2C%20newspapers%20scattered%2C%20energetic%20and%20inviting%20atmosphere%2C%20editorial%20broadcast%20photography%20with%20soft%20golden%20hour%20tones%20and%20clean%20modern%20studio%20aesthetic&width=800&height=450&seq=programa-sistema-cover-01&orientation=landscape',
    description: 'El despertar de Argentina comienza aquí. Noticias, entrevistas a fondo, debates con los protagonistas de la actualidad y la mejor música para arrancar el día.',
    schedule: 'Lun-Vie 06:00-10:00',
    timezone: 'ART (UTC-3)',
    hostName: 'Martín Castellanos',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Professional%20male%20radio%20host%20in%20his%20thirties%2C%20warm%20confident%20expression%2C%20studio%20microphone%20in%20background%20softly%20blurred%2C%20casual%20elegant%20dark%20shirt%2C%20warm%20studio%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-01&orientation=squarish',
    hostSlug: 'martincastellanos',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    category: 'Noticias',
    followers: 284000,
    rankingPosition: 4,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['noticias', 'actualidad', 'entrevistas', 'matutino', 'política'],
    weeklyGrowth: 12.8,
    postsCount: 45,
    videosCount: 12,
    eventsCount: 3,
    contestsCount: 2,
    clubMembers: 8900,
  },
  {
    programId: 2,
    name: 'Tardes con Vale',
    slug: 'tardes-con-vale',
    coverUrl: 'https://readdy.ai/api/search-image?query=Energetic%20afternoon%20radio%20show%20studio%2C%20colorful%20neon%20signs%20on%20walls%2C%20modern%20pop%20culture%20aesthetic%2C%20pink%20and%20warm%20orange%20ambient%20lighting%2C%20DJ%20mixer%20visible%2C%20vibrant%20youthful%20broadcast%20atmosphere%2C%20editorial%20photography%20with%20clean%20modern%20composition&width=800&height=450&seq=programa-sistema-cover-02&orientation=landscape',
    description: 'El punto de encuentro de la generación conectada. Música, cultura pop, virales, entrevistas a influencers y artistas del momento.',
    schedule: 'Lun-Vie 16:00-19:00',
    timezone: 'CST (UTC-6)',
    hostName: 'Valentina Ríos',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20in%20her%20late%20twenties%2C%20friendly%20smile%2C%20modern%20broadcast%20studio%20with%20warm%20lighting%2C%20stylish%20cream%20blazer%2C%20headphones%20around%20neck%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-02&orientation=squarish',
    hostSlug: 'valerios',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    category: 'Entretenimiento',
    followers: 512000,
    rankingPosition: 1,
    rankingTotal: 315,
    isActive: true,
    isTrending: true,
    tags: ['juvenil', 'cultura-pop', 'música', 'influencers', 'tendencias'],
    weeklyGrowth: 18.5,
    postsCount: 67,
    videosCount: 24,
    eventsCount: 5,
    contestsCount: 4,
    clubMembers: 14200,
  },
  {
    programId: 3,
    name: 'Deporte Total',
    slug: 'deporte-total',
    coverUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20radio%20studio%20with%20multiple%20large%20screens%20showing%20live%20match%20highlights%2C%20sports%20memorabilia%20on%20shelves%2C%20professional%20broadcast%20desk%20with%20sports%20team%20branding%2C%20dramatic%20stadium-like%20lighting%20with%20green%20field%20tones%2C%20editorial%20sports%20photography%20style&width=800&height=450&seq=programa-sistema-cover-03&orientation=landscape',
    description: 'La cita obligada del deporte latinoamericano. Tres horas de análisis táctico profundo, cobertura en directo y la opinión más respetada del periodismo deportivo.',
    schedule: 'Lun-Vie 18:00-21:00',
    timezone: 'CST (UTC-6)',
    hostName: 'Roberto "Beto" Fuentes',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Male%20radio%20sports%20commentator%20in%20his%20forties%2C%20energetic%20expression%2C%20polo%20shirt%2C%20sports%20broadcast%20studio%20with%20screens%2C%20dynamic%20energy%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-03&orientation=squarish',
    hostSlug: 'robertoaguilar',
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    category: 'Deportes',
    followers: 385000,
    rankingPosition: 2,
    rankingTotal: 315,
    isActive: true,
    isTrending: true,
    tags: ['fútbol', 'deportes', 'análisis', 'cobertura-en-vivo', 'ligas'],
    weeklyGrowth: 22.3,
    postsCount: 89,
    videosCount: 45,
    eventsCount: 6,
    contestsCount: 5,
    clubMembers: 18700,
  },
  {
    programId: 4,
    name: 'Modo Creativo',
    slug: 'modo-creativo',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20gaming%20and%20tech%20podcast%20studio%20with%20RGB%20LED%20strips%2C%20multiple%20monitors%20displaying%20game%20streams%2C%20neon%20gaming%20peripherals%2C%20fun%20colorful%20aesthetic%2C%20youthful%20energetic%20broadcast%20atmosphere%2C%20editorial%20photography%20with%20cyberpunk-inspired%20lighting&width=800&height=450&seq=programa-sistema-cover-04&orientation=landscape',
    description: 'Donde el gaming, la tecnología y la cultura geek se encuentran. Reseñas de videojuegos, entrevistas a desarrolladores y la comunidad más activa de la plataforma.',
    schedule: 'Lun-Vie 19:00-21:00',
    timezone: 'ART (UTC-3)',
    hostName: 'Diego Armando Quintero',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Young%20male%20radio%20host%20in%20his%20twenties%2C%20enthusiastic%20and%20charismatic%2C%20modern%20podcast%20studio%2C%20colorful%20hoodie%2C%20genuine%20smile%2C%20creative%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-04&orientation=squarish',
    hostSlug: 'diegomontenegro',
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    category: 'Tecnología',
    followers: 420000,
    rankingPosition: 3,
    rankingTotal: 315,
    isActive: true,
    isTrending: true,
    tags: ['gaming', 'tecnología', 'geek', 'podcast', 'streaming'],
    weeklyGrowth: 30.5,
    postsCount: 78,
    videosCount: 52,
    eventsCount: 4,
    contestsCount: 3,
    clubMembers: 11500,
  },
  {
    programId: 5,
    name: 'Onda Nocturna',
    slug: 'onda-nocturna',
    coverUrl: 'https://readdy.ai/api/search-image?query=Dark%20moody%20night%20radio%20studio%20with%20purple%20and%20magenta%20neon%20ambient%20lighting%2C%20vinyl%20turntables%20visible%2C%20DJ%20mixer%20with%20glowing%20knobs%2C%20atmospheric%20haze%20effect%2C%20sophisticated%20underground%20music%20club%20aesthetic%2C%20editorial%20photography%20with%20deep%20shadows%20and%20colored%20accents&width=800&height=450&seq=programa-sistema-cover-05&orientation=landscape',
    description: 'El after hours del dial. Tres horas de electrónica, indie y sonidos alternativos curados por Álex Mendoza, DJ y productor.',
    schedule: 'Lun-Jue 22:00-01:00',
    timezone: 'COT (UTC-5)',
    hostName: 'Alejandro "Álex" Mendoza',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Male%20radio%20DJ%20and%20music%20host%20in%20his%20thirties%2C%20cool%20and%20stylish%20with%20headphones%2C%20modern%20music%20studio%20with%20vinyl%2C%20black%20t-shirt%2C%20warm%20moody%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-05&orientation=squarish',
    hostSlug: 'andrescastillo',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    category: 'Música',
    followers: 246000,
    rankingPosition: 7,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['electrónica', 'indie', 'DJ', 'nocturno', 'sesiones-en-vivo'],
    weeklyGrowth: 15.2,
    postsCount: 34,
    videosCount: 18,
    eventsCount: 3,
    contestsCount: 1,
    clubMembers: 7200,
  },
  {
    programId: 6,
    name: 'Noticiero Central',
    slug: 'noticiero-central',
    coverUrl: 'https://readdy.ai/api/search-image?query=Serious%20evening%20news%20broadcast%20studio%2C%20large%20world%20map%20screens%2C%20professional%20news%20desk%20with%20multiple%20monitors%2C%20dramatic%20yet%20warm%20studio%20lighting%2C%20authoritative%20journalism%20atmosphere%2C%20clean%20modern%20aesthetic%2C%20editorial%20news%20photography&width=800&height=450&seq=programa-sistema-cover-06&orientation=landscape',
    description: 'El resumen informativo más completo del día. 90 minutos con los hechos que marcaron la jornada, análisis de expertos y el panorama para mañana.',
    schedule: 'Lun-Vie 19:00-20:30',
    timezone: 'ART (UTC-3)',
    hostName: 'Sofía Linares',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20news%20anchor%20in%20her%20early%20thirties%2C%20confident%20and%20poised%20expression%2C%20elegant%20navy%20blazer%2C%20broadcast%20news%20studio%20background%2C%20warm%20professional%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-06&orientation=squarish',
    hostSlug: 'sofialinares',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    category: 'Noticias',
    followers: 198000,
    rankingPosition: 9,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['noticias', 'resumen', 'actualidad', 'análisis', 'nocturno'],
    weeklyGrowth: 9.4,
    postsCount: 56,
    videosCount: 28,
    eventsCount: 1,
    contestsCount: 0,
    clubMembers: 5600,
  },
  {
    programId: 7,
    name: 'El Desparche',
    slug: 'el-desparche',
    coverUrl: 'https://readdy.ai/api/search-image?query=Fun%20casual%20morning%20comedy%20radio%20show%2C%20colorful%20studio%20with%20quirky%20decorations%2C%20hosts%20laughing%20together%2C%20relaxed%20informal%20atmosphere%2C%20bright%20natural%20morning%20light%20streaming%20in%2C%20entertaining%20lifestyle%20broadcast%20photography&width=800&height=450&seq=programa-sistema-cover-07&orientation=landscape',
    description: 'El morning show más divertido de la radio. Humor, juegos con los oyentes, personajes y la dosis justa de noticias para arrancar con buena onda.',
    schedule: 'Lun-Vie 07:00-10:00',
    timezone: 'CST (UTC-6)',
    hostName: 'Ricky Navarro',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Charismatic%20male%20radio%20host%20in%20his%20thirties%2C%20big%20genuine%20laugh%2C%20casual%20colorful%20shirt%2C%20fun%20radio%20studio%20background%2C%20bright%20energetic%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-07&orientation=squarish',
    hostSlug: 'rickynavarro',
    radioName: 'Estéreo Capital',
    radioFrequency: '102.1 FM',
    category: 'Comedia',
    followers: 350000,
    rankingPosition: 5,
    rankingTotal: 315,
    isActive: true,
    isTrending: true,
    tags: ['comedia', 'humor', 'matutino', 'juegos', 'entretenimiento'],
    weeklyGrowth: 24.8,
    postsCount: 72,
    videosCount: 36,
    eventsCount: 3,
    contestsCount: 6,
    clubMembers: 13500,
  },
  {
    programId: 8,
    name: 'Conversaciones Reales',
    slug: 'conversaciones-reales',
    coverUrl: 'https://readdy.ai/api/search-image?query=Intimate%20interview%20style%20radio%20studio%2C%20two%20armchairs%20facing%20each%20other%2C%20warm%20lamp%20lighting%2C%20bookshelves%20in%20background%2C%20cozy%20and%20authentic%20atmosphere%2C%20thoughtful%20conversation%20setting%2C%20editorial%20documentary%20photography%20with%20soft%20golden%20tones&width=800&height=450&seq=programa-sistema-cover-08&orientation=landscape',
    description: 'Entrevistas íntimas con las personas que están cambiando el mundo. Sin guiones, sin prisa. Conversaciones que van más allá del titular.',
    schedule: 'Mar y Jue 20:00-22:00',
    timezone: 'COT (UTC-5)',
    hostName: 'Mariana Duarte',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Thoughtful%20female%20radio%20interviewer%20in%20her%20forties%2C%20warm%20intelligent%20expression%2C%20elegant%20casual%20style%2C%20intimate%20radio%20studio%20setting%2C%20soft%20warm%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-08&orientation=squarish',
    hostSlug: 'marianaduarte',
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    category: 'Entrevistas',
    followers: 188000,
    rankingPosition: 12,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['entrevistas', 'sociedad', 'cultura', 'inspiración', 'historias'],
    weeklyGrowth: 18.2,
    postsCount: 28,
    videosCount: 15,
    eventsCount: 2,
    contestsCount: 1,
    clubMembers: 4800,
  },
  {
    programId: 9,
    name: 'Amanecer Tropical',
    slug: 'amanecer-tropical',
    coverUrl: 'https://readdy.ai/api/search-image?query=Bright%20tropical%20morning%20radio%20studio%2C%20large%20windows%20with%20sea%20view%2C%20palm%20leaf%20decorations%2C%20cheerful%20vibrant%20atmosphere%2C%20soft%20golden%20sunrise%20light%2C%20relaxed%20caribbean%20vibe%2C%20editorial%20lifestyle%20broadcast%20photography&width=800&height=450&seq=programa-sistema-cover-09&orientation=landscape',
    description: 'El despertar caribeño con la mejor actitud. Música tropical, noticias positivas, consejos de bienestar y la energía que necesitás para tu día.',
    schedule: 'Lun-Vie 05:30-09:00',
    timezone: 'COT (UTC-5)',
    hostName: 'Laura Fuentes',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Cheerful%20female%20radio%20host%20in%20her%20thirties%2C%20bright%20warm%20smile%2C%20tropical%20casual%20style%2C%20beach%20view%20outside%20studio%20window%2C%20golden%20natural%20light%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-09&orientation=squarish',
    hostSlug: 'laurafuentes',
    radioName: 'Radio Costa Azul',
    radioFrequency: '88.7 FM',
    category: 'Música',
    followers: 145000,
    rankingPosition: 18,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['tropical', 'caribe', 'bienestar', 'matutino', 'música'],
    weeklyGrowth: 8.7,
    postsCount: 23,
    videosCount: 9,
    eventsCount: 2,
    contestsCount: 2,
    clubMembers: 3800,
  },
  {
    programId: 10,
    name: 'Finanzas al Aire',
    slug: 'finanzas-al-aire',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20financial%20podcast%20studio%2C%20sleek%20minimal%20design%2C%20large%20screens%20with%20stock%20charts%20and%20graphs%2C%20professional%20yet%20approachable%20atmosphere%2C%20warm%20wood%20desk%2C%20clean%20corporate%20aesthetic%2C%20editorial%20business%20photography%20with%20soft%20lighting&width=800&height=450&seq=programa-sistema-cover-10&orientation=landscape',
    description: 'Educación financiera sin vueltas. Inversiones, cripto, ahorro, emprendimiento y todo lo que necesitás saber para hacer crecer tu plata.',
    schedule: 'Lun-Mie-Vie 08:00-10:00',
    timezone: 'COT (UTC-5)',
    hostName: 'Carlos Andrés Mejía',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Professional%20male%20financial%20analyst%20in%20his%20forties%2C%20confident%20knowledgeable%20expression%2C%20modern%20business%20casual%20attire%2C%20financial%20studio%20background%2C%20warm%20office%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-10&orientation=squarish',
    hostSlug: 'carlosmejia',
    radioName: 'Radio Costa Azul',
    radioFrequency: '88.7 FM',
    category: 'Finanzas',
    followers: 212000,
    rankingPosition: 8,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['finanzas', 'inversiones', 'cripto', 'emprendimiento', 'economía'],
    weeklyGrowth: 11.3,
    postsCount: 41,
    videosCount: 20,
    eventsCount: 3,
    contestsCount: 1,
    clubMembers: 6100,
  },
  {
    programId: 11,
    name: 'Clásicos del Mundo',
    slug: 'clasicos-del-mundo',
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20classical%20music%20radio%20studio%2C%20grand%20piano%20in%20background%2C%20vintage%20microphones%2C%20warm%20amber%20lighting%2C%20sophisticated%20cultural%20atmosphere%2C%20timeless%20aesthetic%2C%20editorial%20fine%20art%20photography%20with%20soft%20focus%20and%20rich%20tones&width=800&height=450&seq=programa-sistema-cover-11&orientation=landscape',
    description: 'Un viaje diario por las mejores obras de la música clásica universal. Historia, contexto y las interpretaciones más destacadas de cada pieza.',
    schedule: 'Lun-Vie 10:00-13:00',
    timezone: 'PET (UTC-5)',
    hostName: 'Enrique Palacios',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Distinguished%20male%20classical%20music%20radio%20host%20in%20his%20fifties%2C%20cultured%20refined%20expression%2C%20elegant%20blazer%2C%20classical%20music%20studio%20with%20warm%20ambient%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-11&orientation=squarish',
    hostSlug: 'enriquepalacios',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    category: 'Cultura',
    followers: 89000,
    rankingPosition: 25,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['música-clásica', 'cultura', 'historia', 'arte', 'orquestas'],
    weeklyGrowth: 4.5,
    postsCount: 18,
    videosCount: 7,
    eventsCount: 4,
    contestsCount: 0,
    clubMembers: 2400,
  },
  {
    programId: 12,
    name: 'El Caleidoscopio',
    slug: 'el-caleidoscopio',
    coverUrl: 'https://readdy.ai/api/search-image?query=Artsy%20colorful%20cultural%20radio%20studio%2C%20abstract%20paintings%20on%20walls%2C%20eclectic%20furniture%2C%20creative%20messy%20organized%20chaos%2C%20warm%20creative%20lighting%2C%20bohemian%20intellectual%20atmosphere%2C%20editorial%20arts%20and%20culture%20photography&width=800&height=450&seq=programa-sistema-cover-12&orientation=landscape',
    description: 'Cine, teatro, literatura y artes visuales en un solo programa. Reseñas, debates y descubrimientos culturales con invitados del mundo artístico.',
    schedule: 'Mar-Jue-Sab 15:00-17:00',
    timezone: 'PET (UTC-5)',
    hostName: 'Claudia Bermúdez',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Artistic%20female%20radio%20host%20in%20her%20thirties%2C%20creative%20bohemian%20style%2C%20warm%20intellectual%20expression%2C%20colorful%20artsy%20studio%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-12&orientation=squarish',
    hostSlug: 'claudiabermudez',
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    category: 'Cultura',
    followers: 73000,
    rankingPosition: 31,
    rankingTotal: 315,
    isActive: false,
    isTrending: false,
    tags: ['cine', 'teatro', 'literatura', 'arte', 'cultura'],
    weeklyGrowth: 3.2,
    postsCount: 15,
    videosCount: 5,
    eventsCount: 5,
    contestsCount: 1,
    clubMembers: 1800,
  },
  {
    programId: 13,
    name: 'Noches de Nostalgia',
    slug: 'noches-de-nostalgia',
    coverUrl: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20night%20radio%20studio%2C%20vinyl%20records%20collection%20on%20walls%2C%20vintage%20radio%20equipment%2C%20soft%20amber%20desk%20lamp%20lighting%2C%20cozy%20retro%20atmosphere%2C%20sentimental%20mood%2C%20editorial%20photography%20with%20warm%20sepia%20tones&width=800&height=450&seq=programa-sistema-cover-13&orientation=landscape',
    description: 'Canciones que marcaron épocas. Desde los 60s hasta los 2000s, un recorrido musical con historias, anécdotas y los oyentes como protagonistas.',
    schedule: 'Sab-Dom 22:00-01:00',
    timezone: 'VET (UTC-4)',
    hostName: 'Rosa Martínez',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Mature%20female%20radio%20host%20in%20her%20fifties%2C%20warm%20nostalgic%20smile%2C%20elegant%20casual%20style%2C%20cozy%20radio%20studio%20with%20vinyl%20records%2C%20golden%20lamp%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-13&orientation=squarish',
    hostSlug: 'rosamartinez',
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    category: 'Música',
    followers: 158000,
    rankingPosition: 14,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['nostalgia', 'clásicos', 'retro', 'recuerdos', 'baladas'],
    weeklyGrowth: 7.8,
    postsCount: 22,
    videosCount: 6,
    eventsCount: 1,
    contestsCount: 2,
    clubMembers: 4200,
  },
  {
    programId: 14,
    name: 'Conexión Deportiva AM',
    slug: 'conexion-deportiva-am',
    coverUrl: 'https://readdy.ai/api/search-image?query=Early%20morning%20sports%20radio%20show%2C%20sunrise%20light%20through%20stadium-view%20windows%2C%20sports%20newspapers%20and%20coffee%20on%20desk%2C%20athletic%20energy%2C%20fresh%20morning%20atmosphere%2C%20professional%20sports%20journalism%20broadcast%20photography&width=800&height=450&seq=programa-sistema-cover-14&orientation=landscape',
    description: 'La primera cita deportiva del día. Resumen de la jornada anterior, portadas de diarios, y todo lo que tenés que saber antes de salir de casa.',
    schedule: 'Lun-Vie 05:00-08:00',
    timezone: 'CST (UTC-6)',
    hostName: 'Mario Espinoza',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Energetic%20male%20sports%20radio%20host%20in%20his%20thirties%2C%20morning%20fresh%20look%2C%20sporty%20casual%20polo%2C%20early%20morning%20studio%20with%20sunrise%20view%2C%20bright%20clean%20lighting%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-14&orientation=squarish',
    hostSlug: 'marioespinoza',
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    category: 'Deportes',
    followers: 167000,
    rankingPosition: 16,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['deportes', 'matutino', 'resumen', 'fútbol', 'noticias'],
    weeklyGrowth: 6.1,
    postsCount: 38,
    videosCount: 14,
    eventsCount: 1,
    contestsCount: 1,
    clubMembers: 3500,
  },
  {
    programId: 15,
    name: 'Tardes Musicales',
    slug: 'tardes-musicales',
    coverUrl: 'https://readdy.ai/api/search-image?query=Warm%20afternoon%20music%20radio%20studio%2C%20acoustic%20guitar%20on%20wall%2C%20vinyl%20record%20player%2C%20golden%20late%20afternoon%20sunlight%20through%20windows%2C%20relaxed%20cozy%20atmosphere%2C%20music%20lover%20sanctuary%2C%20editorial%20lifestyle%20photography%20with%20warm%20tones&width=800&height=450&seq=programa-sistema-cover-15&orientation=landscape',
    description: 'La banda sonora de tus tardes. Clásicos de todos los tiempos, nuevas joyas musicales, historias detrás de las canciones y pedidos de los oyentes.',
    schedule: 'Lun-Vie 14:00-17:00',
    timezone: 'ART (UTC-3)',
    hostName: 'Carlos Mendoza',
    hostPhotoUrl: 'https://readdy.ai/api/search-image?query=Relaxed%20male%20music%20radio%20host%20in%20his%20forties%2C%20warm%20friendly%20smile%2C%20casual%20linen%20shirt%2C%20afternoon%20light%20in%20music%20studio%2C%20vinyl%20records%20in%20background%2C%20editorial%20portrait%20photography&width=200&height=200&seq=programa-host-15&orientation=squarish',
    hostSlug: 'carlosmendoza',
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    category: 'Música',
    followers: 134000,
    rankingPosition: 22,
    rankingTotal: 315,
    isActive: true,
    isTrending: false,
    tags: ['música', 'clásicos', 'tarde', 'pedidos', 'variado'],
    weeklyGrowth: 5.3,
    postsCount: 20,
    videosCount: 8,
    eventsCount: 2,
    contestsCount: 2,
    clubMembers: 2900,
  },
];

export const sistemaProgramasStats = {
  totalPrograms: 315,
  trendingCount: 4,
  mostFollowed: 10,
  onAirNow: 14,
  totalFollowers: '4.2M',
  categoriesCount: 8,
};

export function getTrendingProgramas(): ProgramaSistema[] {
  return programasSistema.filter((p) => p.isTrending);
}

export function getMostFollowedProgramas(): ProgramaSistema[] {
  return [...programasSistema].sort((a, b) => b.followers - a.followers).slice(0, 10);
}

export function getTopRankingProgramas(): ProgramaSistema[] {
  return [...programasSistema].sort((a, b) => a.rankingPosition - b.rankingPosition);
}

export function getProgramasAlAire(): ProgramaSistema[] {
  return programasSistema.filter((p) => p.isActive);
}

export function getProgramaBySlug(slug: string): ProgramaSistema | undefined {
  return programasSistema.find((p) => p.slug === slug);
}